import { render, staticRenderFns } from "./bl-sample.vue?vue&type=template&id=66c79bee&scoped=true"
import script from "./bl-sample.vue?vue&type=script&lang=js"
export * from "./bl-sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c79bee",
  null
  
)

export default component.exports